import {useAppSelector} from "@Hooks/selector/useAppSelector";
import useIsMobile from "@Hooks/selector/useIsMobile";
import IconCar from "@Icons/ticket/addons/IconCar";
import AddTicketExtra from "@CheckOrder/components/AddTicketExtra";

type AddVehicleButtonProps = {
    label: string,
    description: string,
    onClick: () => void,
    isConfirm?: boolean,
}

function AddVehicleButton({label, description, onClick, isConfirm}: AddVehicleButtonProps) {
    const {passengerDataUpdating} = useAppSelector((state) => state.checkOrder)
    const isMobile = useIsMobile()

    return (
        <AddTicketExtra
            title={label}
            description={description}
            icon={(
                <IconCar
                    width={isMobile ? "24" : "32"}
                    height={isMobile ? "24" : "32"}
                />
            )}
            openSelection={onClick}
            isUpdating={passengerDataUpdating}
        />
    );
}

export default AddVehicleButton;